// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cfm {
    width: 100%;
    height: 100%;
    display: block;
}

/* ── Base map ── */
.cfm-country {
    fill: #343d4a;
    stroke: rgba(8, 12, 18, 0.75);
    stroke-width: 0.45;
    pointer-events: none;
}

/* ── Flow arcs ── */
@keyframes cfm-arc-draw {
    from { stroke-dashoffset: var(--arc-len, 600); }
    to   { stroke-dashoffset: 0; }
}

@keyframes cfm-origin-pulse {
    0%, 100% { r: 6;  opacity: 0.5; }
    50%       { r: 10; opacity: 0.1; }
}

.cfm-arc {
    stroke: rgba(220, 80, 80, 0.5);
    stroke-width: 1.3;
    fill: none;
    stroke-dasharray: 600;
    stroke-dashoffset: 600;
    animation: cfm-arc-draw 1.2s ease forwards;
    pointer-events: none;
}

.cfm-dot {
    fill: rgba(220, 80, 80, 0.9);
    filter: drop-shadow(0 0 2px rgba(220, 80, 80, 0.6));
    pointer-events: none;
}

.cfm-origin-ring {
    fill: rgba(80, 168, 120, 0.15);
    stroke: rgba(80, 168, 120, 0.8);
    stroke-width: 1.5;
    animation: cfm-origin-pulse 2.4s ease-in-out infinite;
    pointer-events: none;
}

.cfm-origin-dot {
    fill: #50a878;
    filter: drop-shadow(0 0 3px rgba(80, 168, 120, 0.7));
    pointer-events: none;
}

.cfm-dest-ring {
    fill: rgba(220, 80, 80, 0.12);
    stroke: rgba(220, 80, 80, 0.6);
    stroke-width: 1.2;
    pointer-events: none;
}

.cfm-dest-dot {
    fill: rgba(220, 80, 80, 0.85);
    filter: drop-shadow(0 0 2px rgba(220, 80, 80, 0.5));
    pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Compliance/ComplianceFlowMap.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA,oBAAoB;AACpB;IACI,OAAO,sCAAsC,EAAE;IAC/C,OAAO,oBAAoB,EAAE;AACjC;;AAEA;IACI,WAAW,IAAI,GAAG,YAAY,EAAE;IAChC,YAAY,KAAK,EAAE,YAAY,EAAE;AACrC;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,UAAU;IACV,qBAAqB;IACrB,sBAAsB;IACtB,0CAA0C;IAC1C,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;IAC5B,mDAAmD;IACnD,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,iBAAiB;IACjB,qDAAqD;IACrD,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,oDAAoD;IACpD,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,mDAAmD;IACnD,oBAAoB;AACxB","sourcesContent":[".cfm {\n    width: 100%;\n    height: 100%;\n    display: block;\n}\n\n/* ── Base map ── */\n.cfm-country {\n    fill: #343d4a;\n    stroke: rgba(8, 12, 18, 0.75);\n    stroke-width: 0.45;\n    pointer-events: none;\n}\n\n/* ── Flow arcs ── */\n@keyframes cfm-arc-draw {\n    from { stroke-dashoffset: var(--arc-len, 600); }\n    to   { stroke-dashoffset: 0; }\n}\n\n@keyframes cfm-origin-pulse {\n    0%, 100% { r: 6;  opacity: 0.5; }\n    50%       { r: 10; opacity: 0.1; }\n}\n\n.cfm-arc {\n    stroke: rgba(220, 80, 80, 0.5);\n    stroke-width: 1.3;\n    fill: none;\n    stroke-dasharray: 600;\n    stroke-dashoffset: 600;\n    animation: cfm-arc-draw 1.2s ease forwards;\n    pointer-events: none;\n}\n\n.cfm-dot {\n    fill: rgba(220, 80, 80, 0.9);\n    filter: drop-shadow(0 0 2px rgba(220, 80, 80, 0.6));\n    pointer-events: none;\n}\n\n.cfm-origin-ring {\n    fill: rgba(80, 168, 120, 0.15);\n    stroke: rgba(80, 168, 120, 0.8);\n    stroke-width: 1.5;\n    animation: cfm-origin-pulse 2.4s ease-in-out infinite;\n    pointer-events: none;\n}\n\n.cfm-origin-dot {\n    fill: #50a878;\n    filter: drop-shadow(0 0 3px rgba(80, 168, 120, 0.7));\n    pointer-events: none;\n}\n\n.cfm-dest-ring {\n    fill: rgba(220, 80, 80, 0.12);\n    stroke: rgba(220, 80, 80, 0.6);\n    stroke-width: 1.2;\n    pointer-events: none;\n}\n\n.cfm-dest-dot {\n    fill: rgba(220, 80, 80, 0.85);\n    filter: drop-shadow(0 0 2px rgba(220, 80, 80, 0.5));\n    pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
